// @systeme: interface
// L'espace de Juliette : réservé aux admins (le serveur vérifie aussi). Un bandeau, des
// onglets, et le contenu. Sobre : c'est un outil de travail, pas l'app.
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { Link as LienRouteur, Navigate, Outlet, useLocation, useNavigate } from 'react-router';
import { api } from '../../lib/api';
import { useSession } from '../../session/SessionContext';
import { Chargement } from '../../composants/Chargement';
import { tailles } from '../../theme/theme';

const ONGLETS = [
  { chemin: '/admin', libelle: 'Chiffres' },
  { chemin: '/admin/foyers', libelle: 'Foyers' },
  { chemin: '/admin/retours', libelle: 'Retours' },
  { chemin: '/admin/support', libelle: 'Support' },
  { chemin: '/admin/reglages', libelle: 'Réglages' },
  { chemin: '/admin/plans', libelle: 'Formules' },
  { chemin: '/admin/prompts', libelle: 'Prompts' },
  { chemin: '/admin/interrupteurs', libelle: 'Interrupteurs' },
  { chemin: '/admin/appels', libelle: 'Appels IA' },
  { chemin: '/admin/journal', libelle: 'Journal' },
] as const;

export function CoquilleAdmin() {
  const { etat } = useSession();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [verifiee, setVerifiee] = useState<boolean | undefined>();

  // La double authentification est obligatoire : sans code récent, on va le demander.
  useEffect(() => {
    if (etat.etat !== 'connectee' || !etat.session.utilisateur.admin) return;
    api.admin
      .deuxFacteurs()
      .then((d) => setVerifiee(d.verifiee))
      .catch(() => setVerifiee(false));
  }, [etat]);

  useEffect(() => {
    if (verifiee === false && pathname !== '/admin/verification') navigate('/admin/verification');
  }, [verifiee, pathname, navigate]);

  if (etat.etat === 'chargement') return <Chargement />;
  if (etat.etat === 'deconnectee') return <Navigate to="/connexion" replace />;
  if (!etat.session.utilisateur.admin) return <Navigate to="/" replace />;
  if (verifiee === undefined) return <Chargement />;
  const courant = ONGLETS.find((o) => o.chemin === pathname)?.chemin ?? false;
  return (
    <Box sx={{ minHeight: '100dvh', pb: 4 }}>
      <Box component="main" sx={{ maxWidth: 720, mx: 'auto', px: `${tailles.marge}px`, pt: 3 }}>
        <Typography variant="body2" color="text.secondary">
          <LienRouteur to="/moi" style={{ color: 'inherit' }}>
            ← Retour à l’app
          </LienRouteur>
        </Typography>
        <Typography variant="h1" component="h1" sx={{ mt: 1 }}>
          Administration
        </Typography>
        {pathname !== '/admin/verification' && (
          <Tabs
            value={courant}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ mt: 1, mb: 2, borderBottom: 1, borderColor: 'divider' }}
          >
            {ONGLETS.map((o) => (
              <Tab
                key={o.chemin}
                value={o.chemin}
                label={o.libelle}
                component={LienRouteur}
                to={o.chemin}
              />
            ))}
          </Tabs>
        )}
        <Outlet context={{ surCodeVerifie: () => setVerifiee(true) }} />
      </Box>
    </Box>
  );
}
